import packageJson from "../../package.json";

declare const __BUILD_TIME__: string;

export function Footer() {
	const currentYear = new Date().getFullYear();

	return (
		<footer className="fixed bottom-1.5 right-1.5 z-50 group">
			<div className="flex items-center bg-surface-muted border border-border-default rounded text-[10px] text-text-muted overflow-hidden transition-all duration-200">
				<span className="px-1.5 py-0.5">v{packageJson.version}</span>
				<span className="max-w-0 overflow-hidden whitespace-nowrap group-hover:max-w-64 group-hover:px-1.5 group-hover:border-l group-hover:border-border-default transition-all duration-200">
					{__BUILD_TIME__} | © PPE {currentYear}
				</span>
			</div>
		</footer>
	);
}
